import { cn } from '@/ui/utils'
import type { PropsWithChildren } from 'react'
import { Text as RNText, View } from 'react-native'

const HighlightText = ({
	className,
	textClassName,
	children,
}: PropsWithChildren & { className?: string; textClassName?: string }) => {
	return (
		<View
			className={cn(
				'bg-palette_5 px-4 py-2 flex align-middle justify-center items-center min-w-32 w-fit',
				className
			)}
		>
			<RNText className={cn('font-primary font-bold text-palette_3', textClassName)}>
				{children}
			</RNText>
		</View>
	)
}

export { HighlightText }
